import { useQuery, gql } from "@apollo/client";

const query = gql`
  query luke {
    SchoolSettings
      @rest(type: "StudyProgram", path: "/wp-json/acf/v2/options/") {
      acf
    }
  }
`;

export const useSchoolSettings = () => {
  const { loading, data } = useQuery(query);
  const {
    overskrift,
    beskrivelse,
    overskrift_valgfag,
    beskrivelse_valgfag,
    styling,
  } = data?.SchoolSettings?.acf || {};

  return {
    showHours: window.show_hours,
    allowChangeCourses: window.allow_change_courses,
    usePopup: window.use_popup,
    overskrift,
    beskrivelse,
    overskrift_valgfag,
    beskrivelse_valgfag,
    styling,
    loading,
  };
};
